import styles from "../../Pages/Settlements/SettlementResult.module.scss";
import DownloadIcon from "../../Assets/SVG/DownloadIcon";
import {formatNumber} from "../../Utils/NumberUtils";
import React, {useState} from "react";
import {IFileInformationDto} from "../../Apis/Models/IFileDto";
import {saveAs} from "file-saver";
import {useTranslation} from "react-i18next";
import {SettlementEntryDto} from "../../Apis/Models/SettlementSalesDto";

type Props = {
    text: string;
    attachment?: IFileInformationDto;
    quantity?: number;
    amount?: number;
    items?: SettlementEntryDto[];
    onSelect: (entry: SettlementEntryDto) => void;
    isAdmin: boolean,
    currency: string
}
const SettlementStatementBox = ({text, attachment, quantity, amount, items, onSelect, isAdmin, currency}: Props) => {

    const {t} = useTranslation();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    
    const toggleOpen = () => {
        setIsOpen(c => !c)
    }

    const download = async (e: any, file: IFileInformationDto) => {
        e.stopPropagation();
        
        const response = await fetch(file.url);

        const blob = await response.blob();

        saveAs(blob, file.fileName);
    }

    return (
        <div onClick={toggleOpen} className={`${styles.statementBox} ${styles.statementGrid}`}>
            <span className={styles.boldText}>
                {text}
            </span>
            <span>
                {!!attachment && (
                    <DownloadIcon width={15} height={15} onClick={(e) => download(e, attachment)}>
                        {t('showAttachment')}
                    </DownloadIcon>
                )}
            </span>
            <span className={styles.boldText}>
                    {quantity}
            </span>
            <span className={`${styles.boldText} no-wrap`}>
                    {formatNumber(amount ?? 0)} {currency}
            </span>
            {isOpen && (
                <>
                    {items?.map(item => (
                        <div onClick={(e) => {
                            e.stopPropagation();
                            onSelect(item);
                        }} className={styles.sub}>
                            <div>
                                {item.text}
                            </div>
                            <div>
                                {!!item.uploadedFile && (
                                    <DownloadIcon width={15} height={15} onClick={(e) => download(e, item.uploadedFile!)}>
                                        {t('showAttachment')}
                                    </DownloadIcon>
                                )}
                            </div>
                            <div>
                                1
                            </div>
                            <div>
                                {formatNumber(item.amount ?? 0)} {currency}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    )

}

export default SettlementStatementBox